export const MASTER_DATA_JOB_TYPES = 'jobTypes';
export const MASTER_DATA_JOB_CATEGORIES = 'jobCategories';
export const MASTER_DATA_JOB_COST_TYPES = 'jobCostTypes';
export const MASTER_DATA_JOB_COST_SUB_TYPES = 'jobCostSubTypes';
export const MASTER_DATA_ADDITIONAL_CONTACT_ADJUSTER = 'addtionalContactAdjusters';
export const MASTER_DATA_ADDITIONAL_CONTACT_TYPES = 'addtionalContactTypes';
export const MASTER_DATA_CUSTOMERS = 'customers';
export const MASTER_DATA_CUSTOMER_RELATIONSHIP_TYPES = 'customerRelationshipTypes';
export const MASTER_DATA_ALL_CUSTOMERS = 'allCustomers';
export const MASTER_DATA_EVENT_COLORS = 'eventColors';
export const MASTER_DATA_UNITS = 'units';
export const MASTER_DATA_CUSTOMER_TYPES = 'customerTypes';
export const MASTER_DATA_CUSTOMER_STATUSES = 'customerStatuses';
export const MASTER_DATA_JOB_PROPERTIES = 'jobProperties';
export const MASTER_DATA_REFERRAL_SOURCES = 'referralSources';
export const MASTER_DATA_CRM_CATEGORIES = 'crmCategories';
export const MASTER_DATA_CRM_STATUSES = 'crmStatuses';
export const MASTER_DATA_PRICES = 'prices';
export const MASTER_DATA_JOB_STATUSES = 'jobStatuses';
export const MASTER_DATA_JOB_STATUS_CODES = 'jobStatusCodes';
export const MASTER_DATA_SOURCE_OF_LOSSES = 'sourceOfLosses';
export const MASTER_DATA_EQUIPMENTS = 'equipments';
export const MASTER_DATA_DEHU_EQUIPMENTS = 'dehuEquipments';
export const MASTER_DATA_MATERIAL_TYPES = 'materialTypes';
export const MASTER_DATA_ACCESS_CODE = 'accessCode';
export const MASTER_DATA_HAZARD = 'hazard';
export const MASTER_DATA_CUSTOMER_TYPE = 'customerType';
export const MASTER_DATA_TESTING = 'testing';
export const MASTER_DATA_PPE_USED = 'ppeUsed';
export const MASTER_DATA_DEBRIS_DISPOSAL = 'debrisDisposal';
export const MASTER_DATA_BILLING = 'billing';
export const MASTER_DATA_WATER_CLASS = 'waterClass';
export const MASTER_DATA_WATER_CATEGORY = 'waterCategory';
